import React from 'react';
import { ToastContainer } from 'react-toastify';
// import LunchPageRoutes from "./LunchPageRoutes";
import ProtectedRoute from './ContextAuth/ProtectedRoute';
// import { AuthContext } from './ContextAuth/Context';
// import TradeRoute from "./TradeRoute";
import { Routes, Route } from 'react-router-dom';
///
import TradeLayout from './Components/TradeLayout';
import TransactionRequest from './TransactionRequest/TransactionRequest';
import SideBar from './Components/SideBar';
// import TradeNavBar from "./Components/TradeNavBar";
import Dashboard from './Dashboard/Dashboard';
import { TradeCurrency } from './TradeCurrency/TradeCurrency';
import { P2p } from './TradeCurrency/P2p';
import { DirectTrade } from './TradeCurrency/DirectTrade';
import { SellTable } from './TradeCurrency/SellTable';
import { BuyTable } from './TradeCurrency/BuyTable';
import { DirectBuy } from './TradeCurrency/DirectBuy';
import { DirectSell } from './TradeCurrency/DirectSell';
import { PlaceOffer } from './PlaceOder/PlaceOffer';
import { PaymentMethod } from './PaymentMethods/PaymentMethod';
import { Navigate } from 'react-router-dom';
// import { BankAccountDetails } from "./TransactionRequest/BankAccountDetails";
import { Subscription } from './Subscription/Subscription';
import { Ratings } from './Ratings/Ratings';
import { TransactionHistory } from './TransactionHistory/TransactionHistory';
//
import Signin from './SignIn/Signin';
import SignUp from './SignUp/SignUp';
import Homepage from './HomePage/Homepage';
import FxExchange from './FxExchange/FxExchange';
import RenderCI from './SignUp/RenderCI';
import Individual from './SignUp/Individual';
import Corporate from './SignUp/Corporate';
import FxNews from './FxNews/FxNews';
import About from './About/About';
import Company from './SignUp/Company';
import { Otppage } from './Authentication/Otppage';
import { ChangePassword } from './Authentication/ChangePassword';
import { EmailValidation } from './Authentication/EmailValidation';
import Referer from './Referer/Referer';
import Settings from './Settings/Settings';
import ContactUS from './ContactUS/ContactUs';
import MyProfilePage from './Settings/MyProfilePage';
import TransactionRatingPage from './Settings/TransactionRatingPage';
import PrivacyPolicies from './Settings/PrivacyPolicies';
import Faq from './Settings/Faq';
import Notifications from './Notifications/Notifications';
import Notification from './Notifications/Notification';
import UnAuthLayout from './Components/UnAuthLayout';
import TermsAndConditions from './Settings/TermsAndConditions';
import ContactUs from './Settings/ContactUs';
import News from './FxNews/News';

import 'react-toastify/dist/ReactToastify.css';
import MyPasswordChange from './Settings/ChangePassword';
import TransactionPenaltyPage from './Settings/TransactionPenaltyPage';

function App() {
  return (
    <>
      <Routes>
        <Route element={<UnAuthLayout />}>
          <Route index element={<Homepage />} />
          <Route path='fxexchange' element={<FxExchange />} />
          <Route path='fxnews' element={<FxNews />} />
          <Route path='fxnews/:newsId' element={<News />} />
          <Route path='signin' element={<Signin />} />
          <Route path='signup' element={<SignUp />} />
          <Route path='otppage' element={<Otppage />} />
          <Route path='faqs' element={<Faq />} />
          <Route path='terms-and-conditions' element={<TermsAndConditions />} />
          <Route path='contactus' element={<ContactUS />} />
          <Route path='about' element={<About />} />
          <Route path='changepassword' element={<ChangePassword />} />
          <Route path='emailvalidation' element={<EmailValidation />} />
          <Route path='signup/renderci' element={<RenderCI />}>
            <Route index element={<Individual />} />
            <Route path=':individual' element={<Individual />} />
            <Route path='corporate' element={<Corporate />} />
          </Route>
          <Route path='signup/company' element={<Company />} />
        </Route>

        <Route
          path='/'
          element={
            <ProtectedRoute>
              <TradeLayout />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={
              <ProtectedRoute>
                <Navigate to='/dashboard' replace={true} />
              </ProtectedRoute>
            }
          />
          <Route
            path='/dashboard'
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path='tradecurrency'
            element={
              <ProtectedRoute>
                <TradeCurrency />
              </ProtectedRoute>
            }
          >
            <Route
              index
              element={
                <ProtectedRoute>
                  <Navigate to='/tradecurrency/p2p/buy' replace={true} />
                </ProtectedRoute>
              }
            />
            <Route
              path='p2p'
              element={
                <ProtectedRoute>
                  <P2p />
                </ProtectedRoute>
              }
            >
              <Route
                index
                element={
                  <ProtectedRoute>
                    <BuyTable />
                  </ProtectedRoute>
                }
              />
              <Route
                path='buy'
                element={
                  <ProtectedRoute>
                    <BuyTable />
                  </ProtectedRoute>
                }
              />
              <Route
                path='sell'
                element={
                  <ProtectedRoute>
                    <SellTable />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path='direct'
              element={
                <ProtectedRoute>
                  <DirectTrade />
                </ProtectedRoute>
              }
            >
              <Route
                index
                element={
                  <ProtectedRoute>
                    {' '}
                    <Navigate
                      to='/tradecurrency/direct/buy'
                      replace={true}
                    />{' '}
                  </ProtectedRoute>
                }
              />
              <Route
                path='buy'
                element={
                  <ProtectedRoute>
                    <DirectBuy />{' '}
                  </ProtectedRoute>
                }
              />
              <Route
                path='sell'
                element={
                  <ProtectedRoute>
                    <DirectSell />{' '}
                  </ProtectedRoute>
                }
              />
            </Route>
          </Route>
          <Route
            path='transactionrequest'
            element={
              <ProtectedRoute>
                <TransactionRequest />{' '}
              </ProtectedRoute>
            }
          />
          <Route
            path='placeorder'
            element={
              <ProtectedRoute>
                <PlaceOffer />
              </ProtectedRoute>
            }
          />
          <Route
            path='transactionhistory'
            element={
              <ProtectedRoute>
                <TransactionHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path='paymentmethod'
            element={
              <ProtectedRoute>
                <PaymentMethod />
              </ProtectedRoute>
            }
          />
          <Route
            path='subscription'
            element={
              <ProtectedRoute>
                <Subscription />
              </ProtectedRoute>
            }
          />
          <Route
            path='referrer'
            element={
              <ProtectedRoute>
                <Referer />
              </ProtectedRoute>
            }
          />
          <Route
            path='subaccount'
            element={
              <ProtectedRoute>
                <SideBar />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings'
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings/profile'
            element={
              <ProtectedRoute>
                <MyProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings/password-change'
            element={
              <ProtectedRoute>
                <MyPasswordChange />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings/penalties'
            element={
              <ProtectedRoute>
                <TransactionPenaltyPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings/ratings'
            element={
              <ProtectedRoute>
                <TransactionRatingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings/privacypolicies'
            element={
              <ProtectedRoute>
                <PrivacyPolicies />
              </ProtectedRoute>
            }
          />{' '}
          <Route
            path='settings/faq'
            element={
              <ProtectedRoute>
                <Faq />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings/contact-us'
            element={
              <ProtectedRoute>
                <ContactUs />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings/terms-and-conditons'
            element={
              <ProtectedRoute>
                <TermsAndConditions />
              </ProtectedRoute>
            }
          />
          <Route
            path='settings/privacypolicy'
            element={
              <ProtectedRoute>
                <PrivacyPolicies />
              </ProtectedRoute>
            }
          />
          <Route
            path='notifications'
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path='notifications/:notification'
            element={
              <ProtectedRoute>
                <Notification />
              </ProtectedRoute>
            }
          />
          <Route
            path='about'
            element={
              <ProtectedRoute>
                <SideBar />
              </ProtectedRoute>
            }
          />
          <Route
            path='ratings'
            element={
              <ProtectedRoute>
                <Ratings />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
      <ToastContainer limit={3} />
    </>
  );
}
export default App;
